import Axios from "@/plugins/Axios";

export class TiposDeAtendimentoService {
  async syncAll() {
    const response = await Axios().get("tipos-de-atendimento");

    return response.data;
  }

  async criar(tipo) {
    const response = await Axios().post("tipos-de-atendimento", tipo);

    return response.data;
  }

  async atualizar(tipo) {
    const response = await Axios().put(`tipos-de-atendimento/${tipo.id}`, tipo);

    return response.data;
  }

  async deletar(tipo) {
    const response = await Axios().delete(`tipos-de-atendimento/${tipo.id}`);

    return response.data;
  }
}

export default new TiposDeAtendimentoService();
